var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-input",
        _vm._g(
          _vm._b(
            {
              style: { width: _vm.width + "px" },
              attrs: { disable: _vm.disable, after: _vm.after }
            },
            "q-input",
            _vm.$attrs,
            false
          ),
          _vm.inputListeners
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }